import React, {useState} from 'react';
import {AccentColorOptions} from 'epic-ue-theme';
import {Select, SelectMenuItem, Typography} from '../';
import {SelectDropdownWrapper} from './SelectDropdown.styles';

export interface DropdownItemProps {
    id: number;
    label: string;
}

export interface SelectDropdownProps {
    accentColor?: AccentColorOptions;
    selectPlaceholder?: string;
    itemSelected?: number | null;
    items?: DropdownItemProps[];
    onChange?: (value: number) => void;
    disable?: boolean;
}

export const SelectDropdown = ({
    accentColor = 'sky',
    disable,
    selectPlaceholder,
    itemSelected,
    items = [],
    onChange
}: SelectDropdownProps): JSX.Element => {
    const validPlaceholder =
        selectPlaceholder && Boolean(items.filter(({label}) => label === selectPlaceholder).length);
    const [selectedItem, setSelectedItem] = useState(
        validPlaceholder ? selectPlaceholder : itemSelected
    );

    const placeholder = selectPlaceholder || '- Select -';

    const selectMenuItems: JSX.Element[] = items.map((item) => (
        <SelectMenuItem
            disabled={item.id === itemSelected}
            id={`dropdown-item-${item.id}`}
            key={`dropdown-item-${item.id}`}
            value={item.id}>
            {item.label}
        </SelectMenuItem>
    ));

    const getItemLabel = (id: number) => {
        for (const item of items) {
            if (item.id === id) {
                return item.label;
            }
        }
        return id;
    };

    const handleChange = (event: React.ChangeEvent<{value: unknown}>) => {
        if (onChange && typeof onChange === 'function') {
            onChange(event.target.value as number);
            setSelectedItem(event.target.value as string);
        } else {
            setSelectedItem(event.target.value as string);
        }
    };

    return (
        <SelectDropdownWrapper accentColor={accentColor}>
            <Typography variant="h2">
                <Select
                    onChange={handleChange}
                    accentColor={accentColor}
                    value={selectedItem}
                    disabled={disable}
                    renderValue={(value: any) => (value ? getItemLabel(value) : placeholder)}>
                    {selectMenuItems}
                </Select>
            </Typography>
        </SelectDropdownWrapper>
    );
};
